export const footerData = {
    ES: {
        topSection: {
            title: "¿Buscas una alternativa para proyectos de altura y difícil acceso?",
            highlight: " ¡HABLEMOS!",
            //phone: "+52 (735) 147 6308",
            email: "contacto@hisol.mx"
        },
        leftSection: {
            logo: "/assets/imgs/footer/Logo2.svg",
            altText: "HISOL Logo"
        },
        formSection: {
            title: "<span>SOLICITAR</span> COTIZACIÓN",
            fields: {
                namePlaceholder: "NOMBRE",
                emailPlaceholder: "CORREO",
                phonePlaceholder: "TELÉFONO",
                servicePlaceholder: "TIPO DE SERVICIO",
                services: ["Servicio 1", "Servicio 2", "Servicio 3"],
                direccionPlaceholder: "DIRECCIÓN/CIUDAD",
                messagePlaceholder: "MENSAJE",
            },
            buttonText: "ENVIAR",
        },
        infoSection: {
            title: "INFORMACIÓN",
            links: [
                { text: "FAQ's", href: "#FAQ's" },
                { text: "TÉRMINOS Y CONDICIONES", href: "#terms" },
                { text: "AVISO DE PRIVACIDAD", href: "#privacy" },
                { text: "EMPLEO", href: "#jobs" }
            ]
        },
        contactSection: {
            title: "CONTACTO",
            details: [
                {
                    type: "address",
                    value: "Guadalajara, Jalisco",
                    svg: (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5z" />
                        </svg>
                    )
                },
                {
                    type: "phone",
                    value: "+52 (735) 147 6308",
                    svg: (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M6.62 10.79a15.466 15.466 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.27c1.21.49 2.54.76 3.91.76a1 1 0 011 1v3.59a1 1 0 01-1 1C9.92 22 2 14.08 2 5.5a1 1 0 011-1h3.59a1 1 0 011 1c0 1.37.27 2.7.76 3.91a1 1 0 01-.26 1.11l-2.2 2.2z" />
                        </svg>
                    )
                },
                {
                    type: "email",
                    value: "contacto@hisol.mx",
                    svg: (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 2l-8 5-8-5h16zm-8 7l-8-5v10h16V8l-8 5z" />
                        </svg>
                    )
                }
            ],
            socialTitle: "<span>SÍGUENOS EN</span> </br>REDES SOCIALES",
            socials: [
                {
                    platform: "facebook",
                    href: "https://www.facebook.com/Hisol.GranAltura",
                    svg: (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z" /></svg>
                    )
                },
                {
                    platform: "instagram",
                    href: "https://www.instagram.com/hisol.ca?igsh=eXUzMHh5MnplZGxv",
                    svg: (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" /></svg>
                    )
                },
                {
                    platform: "youtube",
                    href: "https://youtube.com/@hisol.granaltura?si=h6r8nv7yAnaQYusL",
                    svg: (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                            <path d="M549.655 124.083C537.717 86.053 502.982 64 463.606 64H112.392C73.018 64 38.283 86.053 26.345 124.083 8.635 184.99 0 256 0 256s8.635 71.01 26.345 131.917c11.938 38.03 46.673 60.083 85.047 60.083h351.213c39.376 0 74.111-22.053 86.049-60.083C567.365 327.01 576 256 576 256s-8.635-71.01-26.345-131.917zM232 336.522V175.477L360.58 256 232 336.522z" />
                        </svg>
                    )
                },
                {
                    platform: "tiktok",
                    href: "https://www.tiktok.com/@hisol.ca?_t=ZS-8wKstOhAZgy&_r=1",
                    svg: (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z" /></svg>
                    )
                },
                {
                    platform: "linkedin",
                    href: "https://www.linkedin.com/company/hisol-mexico/",
                    svg: (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                            <path d="M100.28 448H7.4V148.9h92.88zm-46.44-340.8a53.64 53.64 0 1 1 53.64-53.64 53.64 53.64 0 0 1-53.64 53.64zm394.68 340.8h-92.68V302.4c0-34.7-12.46-58.4-43.6-58.4-23.78 0-37.96 16-44.2 31.4-2.28 5.5-2.84 13.2-2.84 20.8V448h-92.68s1.24-248.7 0-274.1h92.68v38.8c-.18.3-.43.7-.61 1h.61v-1c12.33-19 34.38-46.1 83.6-46.1 61 0 106.68 39.8 106.68 125.3V448z" />
                        </svg>
                    )
                }

            ]
        },
        bottomText: "© HISOL. {{year}}. TODOS LOS DERECHOS RESERVADOS."
    },
    // EN: {
    //     topSection: {
    //         title: "Are you looking for an alternative for high-altitude and hard-to-reach projects?",
    //         highlight: "LET'S TALK!",
    //         // phone: "+52 (735) 147 6308",
    //         email: "contacto@hisol.mx"
    //     },
    //     leftSection: {
    //         logo: "/assets/imgs/footer/LOGO.png",
    //         altText: "HISOL Logo"
    //     },
    //     formSection: {
    //         title: "<span>REQUEST A</span> <br/>QUOTE",
    //         fields: {
    //             namePlaceholder: "NAME",
    //             emailPlaceholder: "EMAIL",
    //             phonePlaceholder: "PHONE",
    //             servicePlaceholder: "TYPE OF SERVICE",
    //             services: ["Service 1", "Service 2", "Service 3"],
    //             direccionPlaceholder: "ADDRESS/CITY",
    //             messagePlaceholder: "MESSAGE",
    //         },
    //         buttonText: "SEND",
    //     },
    //     infoSection: {
    //         title: "INFORMATION",
    //         links: [
    //             { text: "FAQ´s", href: "#FAQ´s" },
    //             { text: "TERMS AND CONDITIONS", href: "#terms" },
    //             { text: "PRIVACY NOTICE", href: "#privacy" },
    //             { text: "JOBS", href: "#jobs" }
    //         ]
    //     },
    //     contactSection: {
    //         title: "CONTACT",
    //         details: [
    //             {
    //                 type: "address",
    //                 value: "Guadalajara, Jalisco",
    //                 svg: (
    //                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    //                         <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5z" />
    //                     </svg>
    //                 )
    //             },
    //             {
    //                 type: "phone",
    //                 value: "+52 (735) 147 6308",
    //                 svg: (
    //                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    //                         <path d="M6.62 10.79a15.466 15.466 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.27c1.21.49 2.54.76 3.91.76a1 1 0 011 1v3.59a1 1 0 01-1 1C9.92 22 2 14.08 2 5.5a1 1 0 011-1h3.59a1 1 0 011 1c0 1.37.27 2.7.76 3.91a1 1 0 01-.26 1.11l-2.2 2.2z" />
    //                     </svg>
    //                 )
    //             },
    //             {
    //                 type: "email",
    //                 value: "contacto@hisol.mx",
    //                 svg: (
    //                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    //                         <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 2l-8 5-8-5h16zm-8 7l-8-5v10h16V8l-8 5z" />
    //                     </svg>
    //                 )
    //             }
    //         ],
    //         socialTitle: "<span>FOLLOW US</span></br>ON SOCIAL MEDIA",
    //         socials: [
    //             {
    //                 platform: "facebook",
    //                 href: "#facebook",
    //                 svg: (
    //                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z" /></svg>
    //                 )
    //             },
    //             {
    //                 platform: "instagram",
    //                 href: "#instagram",
    //                 svg: (
    //                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" /></svg>
    //                 )
    //             },
    //             {
    //                 platform: "youtube",
    //                 href: "#youtube",
    //                 svg: (
    //                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
    //                         <path d="M549.655 124.083C537.717 86.053 502.982 64 463.606 64H112.392C73.018 64 38.283 86.053 26.345 124.083 8.635 184.99 0 256 0 256s8.635 71.01 26.345 131.917c11.938 38.03 46.673 60.083 85.047 60.083h351.213c39.376 0 74.111-22.053 86.049-60.083C567.365 327.01 576 256 576 256s-8.635-71.01-26.345-131.917zM232 336.522V175.477L360.58 256 232 336.522z" />
    //                     </svg>
    //                 )
    //             },
    //             {
    //                 platform: "tiktok",
    //                 href: "#tiktok",
    //                 svg: (
    //                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z" /></svg>
    //                 )
    //             },
    //             {
    //                 platform: "linkedin",
    //                 href: "#linkedin",
    //                 svg: (
    //                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    //                         <path d="M100.28 448H7.4V148.9h92.88zm-46.44-340.8a53.64 53.64 0 1 1 53.64-53.64 53.64 53.64 0 0 1-53.64 53.64zm394.68 340.8h-92.68V302.4c0-34.7-12.46-58.4-43.6-58.4-23.78 0-37.96 16-44.2 31.4-2.28 5.5-2.84 13.2-2.84 20.8V448h-92.68s1.24-248.7 0-274.1h92.68v38.8c-.18.3-.43.7-.61 1h.61v-1c12.33-19 34.38-46.1 83.6-46.1 61 0 106.68 39.8 106.68 125.3V448z" />
    //                     </svg>
    //                 )
    //             }

    //         ]
    //     },
    //     bottomText: "© HISOL. {{year}}. ALL RIGHTS RESERVED."
    // }
};
